import moment from 'moment-timezone';

import type { Moment } from 'moment-timezone';
import type { MultiFlightCalendarInfo } from 'sonata-static-storage/lib/common/common.types';

/**
 * Flight and line item dates are stored as calendar days at UTC midnight. Reading them in the browser
 * timezone would shift the day for users west of UTC, so keep the UTC calendar day as a local date.
 */
export function toFormattedLocalDate(date: Date | string): Moment {
  return moment(moment.utc(date).format('YYYY-MM-DD'));
}

/**
 * Keeps the UTC calendar day of every calendar range so the library calendar, which reads dates in the
 * browser timezone, shows the right day.
 */
export function normalizeCalendarInfo(calendarInfo: MultiFlightCalendarInfo): MultiFlightCalendarInfo {
  const normalizeRanges = (ranges: MultiFlightCalendarInfo['activeDates']): MultiFlightCalendarInfo['activeDates'] =>
    ranges.map(([start, end]) => [toFormattedLocalDate(start).toDate(), toFormattedLocalDate(end).toDate()]);

  return {
    ...calendarInfo,
    activeDates: normalizeRanges(calendarInfo.activeDates),
    availableDates: normalizeRanges(calendarInfo.availableDates)
  };
}

export function convertDatesToStringDateFilter(dates?: {
  beginDate?: Moment | string;
  endDate?: Moment | string;
}): string | undefined {
  const { beginDate, endDate } = dates || {};
  if (!beginDate && !endDate) {
    return undefined;
  }
  const begin = beginDate ? moment(beginDate, 'YYYY-MM-DD').startOf('day').format('YYYY-MM-DDTHH:mm:ssZ') : undefined;
  const end = endDate ? moment(endDate, 'YYYY-MM-DD').endOf('day').format('YYYY-MM-DDTHH:mm:ssZ') : undefined;
  if (begin && end) {
    return `${begin}@${end}`;
  }
  if (begin) {
    return `${begin}@`;
  }
  if (end) {
    return `@${end}`;
  }

  return undefined;
}
